import { useEffect } from 'react'
import { observer } from 'mobx-react'
import type { ProfilesStoreType } from 'stores/RootStoreModel'
import { ModuleVersions } from './ModuleVersions'
import { getModuleVersionChanges } from './profileUpdateUtils'

interface ModuleVersionsContainerProps {
    profilesStore: ProfilesStoreType
    profileId: string
    // When given, shows the change from this profile's version of each module
    installedProfileId?: string
}

// Fetches the module versions of a profile (and of the installed profile, for the changes) when first shown
export const ModuleVersionsContainer = observer(({ profilesStore, profileId, installedProfileId }: ModuleVersionsContainerProps) => {
    useEffect(() => {
        profilesStore.fetchModuleVersionsIfNeeded(profileId)
        if (installedProfileId !== undefined) {
            profilesStore.fetchModuleVersionsIfNeeded(installedProfileId)
        }
    }, [profilesStore, profileId, installedProfileId])

    const profileIds = installedProfileId !== undefined ? [profileId, installedProfileId] : [profileId]
    const hasError = profileIds.some(id => profilesStore.fetchModuleVersionsStatuses.get(id)?.error)

    const moduleVersions = profilesStore.getModuleVersions(profileId)
    if (installedProfileId === undefined) {
        return <ModuleVersions {...{ moduleVersions, hasError }} />
    }
    const installedModuleVersions = profilesStore.getModuleVersions(installedProfileId)
    return <ModuleVersions {...{
        moduleVersions: moduleVersions !== null && installedModuleVersions !== null
            ? getModuleVersionChanges(installedModuleVersions, moduleVersions)
            : null,
        hasError,
    }} />
})
